import { gql } from '@apollo/client';

export const GET_SUBSCRIPTIONS = gql`
  query getSubscriptions {
    subscriptions: getSubscriptions {
      type
      id
      name
      logo
      grade
      flyerCounters {
        name
        frequency
        amount
      }
    }
  }
`;
